import service from "../../../../../api/services";
import { FetchProductByModelProps } from "../interface";

const fetchProductByModel = async ({
    brand_name,
    product_type,
    search,
    setProductDataByModel,
}: FetchProductByModelProps) => {
    try {
        const data = {
            brand_name: brand_name,
            product_type: product_type,
            search: search,
        };
        const productData = await service.product.fetchProductsByModel(data);
        setProductDataByModel(productData?.data?.data);
    } catch (error) {
        console.error(error);
    }
};

export default fetchProductByModel;
